import { render, staticRenderFns } from "./TPill.vue?vue&type=template&id=825a4c2a&scoped=true&"
import script from "./TPill.vue?vue&type=script&lang=js&"
export * from "./TPill.vue?vue&type=script&lang=js&"
import style0 from "./TPill.vue?vue&type=style&index=0&id=825a4c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825a4c2a",
  null
  
)

/* custom blocks */
import block0 from "./TPill.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports